import React, { Component } from 'react';
import axios from 'axios';

import {
  NavLink,
  Redirect
} from 'react-router-dom';

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      password2: '',
      success: '',
      error: '',
      redirect: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value
    })
  }

  handleSubmit(event) {
    event.preventDefault();

    var self = this;

    axios.post('https://api.recordatifocus.com/user/login?_format=json', {
      name: this.state.name,
      pass: this.state.password
    })
    .then(function (response) {
      self.setState({
        'success': 'Login successful',
        'error': ''
      });
	
      localStorage.setItem('username', response.data.current_user.name);
      localStorage.setItem('uid', response.data.current_user.uid);
      localStorage.setItem('csrf_token', response.data.csrf_token);
      localStorage.setItem('logout_token', response.data.logout_token);
      localStorage.setItem('auth', window.btoa(self.state.name + ':' + self.state.password));

      self.setState({redirect: true});
    })
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');
      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
  }

  render(){

    var loggedIn = localStorage.getItem("auth");
 
    if (loggedIn) {
      return (
        <div className="row top-buffer">
          <Redirect to="/" />
        </div>
      );
    }

    return (
    <div>
      <div className="row mt-5 position-relative justify-content-center">
        <div className="col-lg-6">
        <div className="text-center fs-3 fw-bolder">Lütfen Giriş Yapınız</div>
        <div className="text-center mb-3">Uygulamaya girebilmek için lütfen e-postanızı ve parolanızı giriniz.</div>
        </div>
    	
      </div>

    
      <div className="row mt-5 mb-5 position-relative justify-content-center">
        <div className="col-lg-4">
          <form className="text-center" onSubmit={this.handleSubmit}>
            <div className="form-group mb-3">
              <input name="name" value={this.state.name} onChange={this.handleChange} required type="text" className="form-control" placeholder="E-posta" />
            </div>
            <div className="form-group mb-3">
              <input name="password" value={this.state.password} onChange={this.handleChange} required type="password" className="form-control" placeholder="Parola" />
            </div>
            <button type="submit" className="btn btn-danger">Giriş Yap</button>
            <div className="form-group messages">
              <p className="success">{this.state.success}</p>
              <p className="error" dangerouslySetInnerHTML={{__html: this.state.error}} />
            </div>
          
            <NavLink className="link-dark text-decoration-none" to="/user/password">Parolamı Unuttum</NavLink>
          </form>
        <div class="cube-code bottom-0 end-0 translate-middle-y d-inline-flex"><p class="p-0 small text-center rotated">COL/RD/1/2024Q3/3</p></div>
        </div>
      </div>
    
    </div>
    
    );
  }
}

export default Login



// WEBPACK FOOTER //
// src/components/login.jsx